import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Form,
  Col,
  Row,
  Card,
  Tag,
  Spin,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/lib/form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import StatCard from 'components/theme_components/StatCard';
import IntermarqueCard from './InterMarqueCard';
import ButtonLink from 'components/theme_components/ButtonLink';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';
import { useQuery } from 'react-query';
import { getSiloBrandList } from 'services/thirdParty';
import { getProductList } from 'services/parametersService';


export type IntermarqueListProps = {
  form: FormInstance;
  tpid: number;
  color: string;
  itemsCompanyHierarchyTree: any[];
  tptype?: string;
  keyProps: string;
};

const IntermarqueList = (props: IntermarqueListProps) => {
  const [visible, setVisible] = React.useState(false);
  const { form, tpid, color, itemsCompanyHierarchyTree, tptype, keyProps } = props;
  const [siloPrCode, setSiloPrCode] = useState("VN");

  const { data: siloList, isLoading, refetch } = useQuery(
    ['getSiloBrandListSILOINTER', keyProps, tpid, siloPrCode],
    () => getSiloBrandList({
      silotpid: tpid,
      siloprcode: siloPrCode,
      silotype: "SILOINTER"
    }).then((res) => {
      if (res.list) {
        res.list.map((silo_Intra: any) => {
          let exclusionsAuthList: any[] = [];
          silo_Intra.siloList.map((silo: any) => {

            silo.tpAuthorizationResponses.map((xsilo: any) => {
              if (xsilo && xsilo.flagexcludpermeabilitypm) {
                exclusionsAuthList.push(xsilo)
              }
            })
          })
          silo_Intra.exclusionsAuthList = exclusionsAuthList;
        });
        return res.list
      }
      return []
    }),
    { enabled: tpid != null }
  );


  const { data: products } = useQuery('getProductList', () =>
    getProductList().then((res) => {
      return res.list || [];
    }),
    { refetchOnWindowFocus: false }
  );


  return (
    <Form form={form}>
      <Row gutter={[16, 16]} justify="center">
        <Col span={24}>
          <StatCard
            title=""
            value="Les exclusions se sont au niveau intra-marque"
            className="mb-5 blue staticNotf"
            variant='secondary'
            valueStyle={{
              whiteSpace: 'pre-line',
            }}
          />
        </Col>
        <Col span={24}>
          {products?.map((product, index) => {
            return (
              <Tag
                key={index}
                color={color}
                className={`tag-status font-size-13 ml-2 p-2 tag-status-${product.prcode == siloPrCode ? 'primary' : 'secondary'}`}
                bordered={false}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setSiloPrCode(product.prcode)
                }}
              >
                {product.prcode}
              </Tag>
            )
          })}

        </Col>
        <Col span={24}>
          <Card className=" transparent">
            <Row gutter={8} justify="start">
              <Col span={3}>
                <GetLabel
                  className="gray-color font-size-13 bold mb-0"
                  label="silosinter"
                />
              </Col>
              <Col span={10}>
                <GetLabel
                  className="gray-color font-size-13 bold mb-0"
                  label="exclusionsinter"
                />
              </Col>
              <Col span={3}>
                <GetLabel
                  className="gray-color mb-0 font-size-13 bold "
                  label="availableamount"
                />
              </Col>

              <Col span={3}>
                <GetLabel
                  className="gray-color mb-0 font-size-13 bold "
                  label="availableamountmpea"
                />
              </Col>
              <Col span={2} />


              <Col span={3} style={{ textAlign: "end" }}>
                {' '}
                <span>
                  {' '}
                  <GetLabel
                    className="gray-color font-size-13 bold text-right mb-0 "
                    label="update"
                  />
                </span>{' '}
                <span>
                  <GetLabel
                    className=" gray-color font-size-13 bold text-right mb-0 ml-2 "
                    label="delet"
                  />
                </span>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24} className="mb-8">
          {isLoading ? <Row justify="center" style={{ marginTop: 15, marginBottom: 10 }}>
            <Spin spinning={isLoading} />
          </Row> : <>
            {siloList?.map((siloInter) => (
              <IntermarqueCard refetch={() => {
                refetch();
              }} key={siloInter.siloid} siloInter={siloInter} action="edit" tpid={tpid} hideDeletebtn={false} />
            ))}

          </>}



        </Col>
      </Row>
      <Row
        gutter={[16, 16]}
        justify="center"
        className="ml-0 mr-0 pb-20 "
        style={{ marginTop: 30 }}
      >
        <Col>

          <TaskSButtonSFS
            clientName=""
            entityId={tpid}
            entityReference=""
            entityName="THIRDPARTY"
            tptype={tptype}
            currcode=""
            funcode="evcreatesilointer"
            wizardsteps
            // refetch={() => refetch()}
            width={1000}
            title="evcreatesilointer"
            refetch={() => {
              refetch()
            }}
            prcodeProps={siloPrCode}
          >
            <ButtonLink
              type="primary"
              comcode="addgrpsilos"
              className="ut-reset-btn"
              icon={<PlusOutlined />}
            />
          </TaskSButtonSFS>
        </Col>
      </Row>
    </Form >
  );
};

export default IntermarqueList;
